import { isArray } from 'lodash'
import { logError } from '../utils'

export function checkProps(props) {
  const { cacheSize, expandedRowKeys, width, height } = props
  const rules = [
    {
      match: () => cacheSize < 0,
      action: () => logError('cacheSize must be greater than 0'),
    },
    {
      match: () => !isArray(expandedRowKeys),
      action: () => logError('expandedRowKeys needs to be an array'),
    },
    {
      match: () => !width && height,
      action: () => logError('Width is a must'),
    },
    {
      match: () => width && !height,
      action: () => logError('Height is a must'),
    },
    {
      match: () => width && !isFinite(width),
      action: () => logError('Width must be a valid number'),
    },
    {
      match: () => height && !isFinite(height),
      action: () => logError('height must be a valid number'),
    },

  ]
  for (let i = 0; i < rules.length; i++) {
    if (rules[i].match()) {
      rules[i].action()
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/props/check-props.js